const CtaScrollSection = (gsap, ScrollTrigger, $) => {

	//the DOM element we would like to pin to the screen, in this case is the left side (title + text + button)
	let leftContainer  = document.querySelector(".scrolling-cta__left");
	// trigger is the DOM element we use to start the pinning, in this case the entire block
	let trigger  = document.querySelector(".scrolling-cta-block");

	let mm = gsap.matchMedia();

	// add a media query. When it matches, the animation will run
	mm.add("(min-width: 1024px)", () => {

		gsap.to(leftContainer, {
			ease: "none",
			scrollTrigger: {
				trigger: trigger,
				pin: leftContainer,
				start: "top top",
				end: "bottom bottom",
				scrub: true,
				// markers: true,
			},
		});
	});

};

export default CtaScrollSection;
